import { styled as e, Box as c, Button as k } from "@mui/material";
import y from "../../../assets/icons/icon-info-invert.svg.js";
import B, { EmailValidationPattern as E } from "./EmailTextField.js";
import O from "./SendEmailOTPButton.js";
import b from "../../share/apeiron/ApeironBlueButton.js";
import T from "../../share/next/Image.js";
import V from "../../share/popup/InfoPopup.js";
import { INFO_POPUP_TYPE as S } from "../../../constants/popup.js";
import { useState as r, useCallback as m } from "react";
import { useTranslation as _ } from "react-i18next";
import { jsxs as a, Fragment as j, jsx as t } from "react/jsx-runtime";
const F = e(c)`
  align-items: flex-start;
  display: flex;
  gap: 10px;
  justify-content: space-between;
  width: 100%;
`, A = e(k)`
  min-width: unset;
  ${(n) => n.theme.breakpoints.up("res480")} {
    padding: 10px;
  }
  ${(n) => n.theme.breakpoints.down("res480")} {
    padding: 10px 4px;
  }
`, N = e(T)`
  aspect-ratio: 1;
  width: 20px;
`, $ = e(V)`
  max-width: 575px;
  width: 100%;
  .Custom-Content {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 20px;
    justify-content: center;
    padding: 20px 40px;
    text-align: center;
  }
`, v = e(c)`
  width: 100%;
  max-width: 100px;
  button {
    width: 100%;
  }
`, Q = (n) => {
  const {
    name: d,
    defaultValue: o,
    otpType: f,
    control: u
  } = n, [x, h] = r(o ? E.test(o) : !1), {
    t: s
  } = _(), [C, g] = r(o || ""), [w, l] = r(!1), I = m(() => {
    l(!0);
  }, []), p = m(() => {
    l(!1);
  }, []);
  return /* @__PURE__ */ a(j, {
    children: [/* @__PURE__ */ a(F, {
      children: [/* @__PURE__ */ t(B, {
        name: d,
        onValueChanged: (i, P) => {
          g(i), i !== "" && i !== void 0 && h(P);
        },
        defaultValue: o,
        control: u
      }), /* @__PURE__ */ t(O, {
        email: C,
        disabled: !x,
        otpType: f
      }), /* @__PURE__ */ t(A, {
        onClick: I,
        children: /* @__PURE__ */ t(N, {
          src: y
        })
      })]
    }), /* @__PURE__ */ a($, {
      type: S.BLACK,
      open: w,
      onClose: p,
      children: [s("account_setting.check_verification_code"), /* @__PURE__ */ t(v, {
        children: /* @__PURE__ */ t(b, {
          onClick: p,
          children: s("common.popup.ok")
        })
      })]
    })]
  });
};
export {
  Q as default
};
//# sourceMappingURL=EmailOTPSender.js.map
